import { BroadcastDate, BroadcastTitle, GoToOverviewNavigation } from '../../atoms';

export const WebinarBasicInfo = () => {
    return (
        <div className="relative flex-1 min-w-56 hidden bc:flex flex-col pl-12 mb-2 lg:mb-0">
            <GoToOverviewNavigation />
            <BroadcastTitle />
            <BroadcastDate />
        </div>
    );
};
